import React from 'react';
import { Box, Text } from '@rsos/components/capstone/base';
import AgencyInvitation from '../AgencyInvitation';
import {
  TableContainer,
  TableHeader,
} from '../LinksToTable/LinksToTable.styles';
import LinksFromRow from './LinksFromRow';

const LinksFromTable = () => {
  return (
    <Box>
      <Text
        color="primaryText"
        data-name="links-from-table-description"
        mb="10px"
        size="small"
      >
        Your agency can receive events from the agencies listed below. In
        addition, you may choose to appear offline or online with the agencies
        below."
      </Text>
      <TableContainer>
        <Box pt="9px" mb="13px" horizontal={true} align="center">
          <Box width="50%">
            <TableHeader>Name</TableHeader>
          </Box>
          <Box width="50%">
            <TableHeader>Status</TableHeader>
          </Box>
        </Box>
        <AgencyInvitation />
        <LinksFromRow />
      </TableContainer>
    </Box>
  );
};

export default LinksFromTable;
